{
  "ShortlistThemePreview": {
    "label": "Shortlist preview",
    "sampleTitle": "Summer campaign",
    "sampleDescription": "Our picks for the summer shoot. Vote for the people you'd like to book.",
    "sampleChipAccent": "Shortlisted",
    "sampleChipTint": "Paris",
    "sampleSecondaryAction": "Filters"
  },
  "public.detail": {
    "search.placeholder": "Search shortlist",
    "hero.shortlistBy": "Shortlist by {{name}}",
    "empty.title": "No one shortlisted",
    "empty.description": "Build your shortlist by selecting resources to present to stakeholders",
    "filters.label": "Filters",
    "item.emptyValue": "n/a",
    "passwordProtection": {
      "enterPassword": "Enter password to view shortlist",
      "placeholder": "Enter password",
      "viewShortlist": "View Shortlist"
    },
    "error": {
      "title": "Error searching shortlist"
    }
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "Belongs to me",
      "createdAt": "Created after {{date}}",
      "publishedOnly": "Published Only",
      "draftOnly": "Draft Only",
      "archived": "Show Archived",
      "between": "Between {{startDate}} - {{endDate}}",
      "tags": {
        "and": " and ",
        "more": " more",
        "any": "Any tag: {{tag}}",
        "match": "Match tags: {{tags}}"
      }
    }
  },
  "GridViewItemGallery": {
    "editGallery": "Edit Gallery",
    "emptyGalleryTitle": "Empty gallery",
    "emptyGalleryDescription": "Add media for this resource",
    "addMedia": "Add media"
  },
  "ShortlistVotes": {
    "upvote": "Upvote",
    "downvote": "Downvote",
    "saveFailed": "Couldn't save your vote. Try again."
  },
  "ShortlistMediaSidebarPage": {
    "draft": "Draft",
    "votingDisabled": "Voting is disabled when the shortlist is not published",
    "commentingDisabled": "Commenting is disabled when the shortlist is not published",
    "votingAndCommentingDisabled": "Voting and commenting are disabled when the shortlist is not published"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "Shortlisted {{count}} of {{totalBlocks}}",
      "previous": "Previous shortlisted",
      "next": "Next shortlisted"
    },
    "CommentList": {
      "label": "Comments",
      "guest": "Guest",
      "noComments": "No comments yet",
      "startConversation": "Be the first to share what you think about {{name}}.",
      "startConversationNoName": "Share what you think about this person with your team.",
      "commentsOff": "Comments are turned off",
      "anonymous": "Anonymous"
    },
    "CommentInput": {
      "writeComment": "Write a comment",
      "addComment": "Add Comment",
      "writeFirstComment": "Write the first comment",
      "sendFailed": "Couldn't send your comment. Try again."
    },
    "GuestNameChangeForm": {
      "title": "Guest Feedback",
      "description": "Enter your name below to leave feedback",
      "placeholder": "Your name",
      "saveChanges": "Save Changes"
    },
    "GuestInfo": {
      "youAre": "You are {{name}}",
      "change": "Change"
    },
    "Details": {
      "noFields": "This shortlist has no fields to show",
      "loadFailed": "The fields couldn't be loaded."
    },
    "Tabs": {
      "label": "Sections",
      "comments": "Comments",
      "details": "Details"
    }
  },
  "SetGuestNameModal": {
    "title": "Set a guest name",
    "description": "You need to tell the shortlist owner who you are before you can vote or comment on people in the shortlist",
    "yourName": "Your name",
    "saveName": "Save Name",
    "successfullyCreated": "Successfully created",
    "guestNameSet": "Guest name set"
  },
  "ShortlistCreateButton": {
    "create": "Create Shortlist"
  },
  "ShortlistCreateDialog": {
    "title": "Create shortlist",
    "description": "Name the new shortlist, describe it and tag it.",
    "titleLabel": "Title",
    "titlePlaceholder": "Shortlist title",
    "titleRequired": "Enter a title",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Shown to clients under the title",
    "tagsLabel": "Tags",
    "create": "Create"
  },
  "CardFieldsDialog": {
    "title": "Card fields",
    "description": "Which fields every card on this shortlist shows, for everyone including the client.",
    "rateHint": "first rate card",
    "noCatalog": "This workspace's resource types have no fields a card can show.",
    "onCards": "On cards",
    "selectedCount": "{{count}} of {{total}} selected",
    "order": "Card fields in order",
    "cut": "Cards show the fields above · details show all",
    "reorderHint": "Drag to reorder. Drag a field above the line to show it on cards.",
    "empty": "No fields yet. Pick them from the resource fields.",
    "preview": "Preview",
    "previewOf": "{{name}} · {{position, number}} of {{total, number}}",
    "previous": "Previous person",
    "next": "Next person",
    "previewEmpty": "Add people to the shortlist to preview a card.",
    "previewHint": "Empty values show \"—\" so every card keeps the same layout.",
    "unnamed": "Unnamed",
    "cancel": "Cancel",
    "onSet": "On set",
    "teamSettings": "Team settings"
  },
  "ClientDefaultFilterDialog": {
    "title": "Client's default filter",
    "description": "Clients open the shortlist with this filter and can clear it for themselves.",
    "filters": "Filters"
  },
  "AvailabilityDialog": {
    "title": "Availability",
    "description": "Whether cards show booking availability and for which dates.",
    "show": {
      "label": "Show availability on cards",
      "description": "Everyone who opens the shortlist sees it, the client too."
    },
    "dates": {
      "label": "Dates",
      "description": "Every booking in these dates counts, whatever its status.",
      "required": "Pick the dates to check"
    },
    "preview": {
      "label": "On the card",
      "range": "{{from}} – {{to}}",
      "available": "Available {{range}}",
      "booked": "{{status}} {{range}}",
      "privacy": "Clients see booking status, never the production name."
    }
  },
  "SharingDialog": {
    "title": "Sharing and access",
    "description": "The client link, who can open it, client feedback and branding.",
    "status": {
      "published": "Published",
      "draft": "Draft"
    },
    "link": {
      "title": "Link",
      "hint": "The client opens the shortlist here. It stays the same after unpublishing and publishing again.",
      "copy": "Copy",
      "draftHint": "Clients can open it once you publish.",
      "missing": "This shortlist has no link yet."
    },
    "access": {
      "title": "Who can open it",
      "link": {
        "label": "Anyone with the link",
        "description": "No password"
      },
      "password": {
        "label": "Link and password",
        "description": "Clients enter it to open the link",
        "placeholder": "Password",
        "show": "Show",
        "hide": "Hide",
        "generate": "Generate",
        "required": "Enter a password or let anyone with the link open it"
      }
    },
    "feedback": {
      "title": "Client feedback",
      "voting": {
        "label": "Voting",
        "description": "Thumbs up or down on each person"
      },
      "comments": {
        "label": "Comments",
        "description": "A thread on each person"
      },
      "shared": {
        "label": "Shared feedback",
        "description": "Clients see each other's votes and comments"
      },
      "notifications": {
        "label": "Email me about new feedback",
        "description": "When someone votes or comments"
      }
    },
    "footer": {
      "published": "Published",
      "publishedOn": "Published {{day}}",
      "notPublished": "Not published yet"
    },
    "publish": "Publish",
    "unpublish": "Unpublish",
    "published": "Published. Clients can open the link now.",
    "unpublished": "Unpublished. The link stays the same for next time."
  },
  "ShortlistBrandingRow": {
    "defaultName": "Atellio",
    "profileHint": "From the public profile settings"
  },
  "ShareStatusButton": {
    "share": "Share",
    "published": "Published",
    "access": {
      "password": "password",
      "link": "anyone with link"
    },
    "copyLink": "Copy link"
  },
  "ShortlistPublicLink": {
    "copied": "Link copied",
    "copyFailed": "Couldn't copy the link. Select it here and copy it yourself:"
  },
  "ShortlistSettingsDialog": {
    "save": "Save for everyone",
    "saved": "Saved for everyone",
    "unsavedChanges": "These settings have unsaved changes",
    "everyoneSees": "everyone sees"
  },
  "BlockGalleryEditDialog": {
    "title": "Edit gallery",
    "description": "The pictures {{name}} shows on this shortlist, in order. The first one is the cover.",
    "thisShortlistOnly": "This shortlist only",
    "everyoneSees": "Saved for everyone on this shortlist, the client included.",
    "cancel": "Cancel",
    "save": "Save gallery",
    "uploading_one": "Uploading {{count}}…",
    "uploading_other": "Uploading {{count}}…",
    "saved": "Gallery saved",
    "profileAddFailed": "The gallery is saved, but the new files couldn't be added to {{name}}'s pinboard.",
    "unsavedChanges": "This gallery has changes you haven't saved.",
    "sources": "Add from",
    "pinboard": "Profile pinboard",
    "loadingPinboard": "Loading the pinboard",
    "pinboardCount": "Profile pinboard · {{count}}",
    "upload": "Upload",
    "searchPins": "Search tagged pins",
    "pinboardHint": "Click or drag a pin into the gallery. It is copied there; the profile stays as it is.",
    "noPins": "{{name}}'s profile has no pins yet. Upload pictures or add a link instead.",
    "noMatches": "No pins tagged “{{query}}”.",
    "uploadFormats": "or onto the gallery · JPG, PNG, WebP or MP4, up to 50 MB each",
    "orAddLink": "Or add from a link",
    "linkHint": "YouTube, Vimeo or a picture's address",
    "alsoAddToProfile": "Also add new files to {{name}}'s profile pinboard",
    "inThisGallery": "In this gallery",
    "startOver": "Start over from the profile",
    "reorderHint": "Drag to reorder. The first one is the cover on the card.",
    "reorderHintNewFiles": "New files join at the end. Drag to reorder; the first one is the cover on the card.",
    "new": "New",
    "empty": "No pictures yet. Pick some in the panel, or drag them here.",
    "linkPreview": {
      "notAUrl": "That isn't a web address",
      "notAUrlHint": "Paste a link starting with https://.",
      "brokenPicture": "Can't load this picture",
      "brokenPictureHint": "Check the address. Some sites don't let other pages show their pictures.",
      "missingVideo": "Can't show this video",
      "missingVideoHint": "It may be private, removed, or the link may be cut short.",
      "unsupported": "This link isn't a picture or a video",
      "unsupportedHint": "Add a YouTube or Vimeo video, or the address of a picture."
    },
    "dropTitle": "Drop pictures or videos here",
    "chooseFiles": "Choose files",
    "addPictures": "Add pictures",
    "picture": "picture",
    "pictures": "pictures",
    "pin": "pin",
    "pins": "pins",
    "addSelected_one": "Add {{count}} pin to the gallery",
    "addSelected_other": "Add {{count}} pins to the gallery",
    "removeSelected_one": "Remove {{count}} from the gallery",
    "removeSelected_other": "Remove {{count}} from the gallery"
  },
  "BlockNote": {
    "label": "Note",
    "placeholder": "Write a bit about {{name}}",
    "placeholderUnnamed": "Write a note"
  },
  "ShortlistCard": {
    "noNote": "No note",
    "available": "Available",
    "booked_one": "{{count}} booking",
    "booked_other": "{{count}} bookings",
    "openGallery": "Open the gallery, picture {{index}} of {{count}}",
    "openGalleryPictures_one": "Open the gallery: {{count}} picture",
    "openGalleryPictures_other": "Open the gallery: {{count}} pictures",
    "previousPicture": "Previous picture",
    "nextPicture": "Next picture",
    "noPictures": "No pictures yet",
    "editGallery": "Edit gallery",
    "addPictures": "Add pictures",
    "pictureUnavailable": "This picture can't be shown",
    "morePictures_one": "{{count}} more picture",
    "morePictures_other": "{{count}} more pictures"
  },
  "ShortlistBoardPage": {
    "closeDetails": "Close details",
    "shortlists": "Shortlists",
    "resourceDetails": "Resource details",
    "belongsElsewhere": "This shortlist belongs to another workspace or team",
    "belongsElsewhereHint": "Open it from the shortlists of the workspace or team it belongs to.",
    "backToShortlists": "Back to shortlists",
    "draft": "Draft",
    "published": "Published",
    "saveFailed": "Couldn’t save the change."
  },
  "ShortlistBoardHeaderActions": {
    "mode": "Mode",
    "edit": "Edit",
    "preview": "Preview",
    "togglePreview": "Toggle preview",
    "feedback": "Feedback · {{count}}",
    "more": "More actions",
    "sharingAndAccess": "Sharing and access"
  },
  "ShortlistBoardBatchActions": {
    "person": "person",
    "people": "people",
    "remove_one": "Remove from shortlist",
    "remove_other": "Remove {{count}} from shortlist",
    "removeFailed": "Couldn't remove them from the shortlist. Try again."
  },
  "ShortlistAddResources": {
    "title": "Add from database",
    "pick": "Pick",
    "alreadyOnShortlist": "Already on this shortlist",
    "noResults": "No resources match.",
    "add": "Add to shortlist",
    "added_one": "Added {{count}} person to the shortlist",
    "added_other": "Added {{count}} people to the shortlist",
    "addFailed": "Couldn’t add them to the shortlist.",
    "available": "Available {{start}} – {{end}}",
    "availableValue": "Available",
    "availableSubject": "In the shortlist’s dates",
    "onlyWorkspace": "Only {{name}}",
    "allWorkspaces": "All workspaces",
    "willJoin_one": "{{count}} person will join {{name}}",
    "willJoin_other": "{{count}} people will join {{name}}",
    "back": "Back",
    "joinAndAdd": "Join and add",
    "notOnShortlist": "Not on this shortlist"
  },
  "ShortlistBoardToolbar": {
    "onlyForMe": "Only for me",
    "sortBy": "Sort: {{field}}",
    "sort": {
      "order": "custom order",
      "votes": "most votes",
      "name": "name",
      "added": "last added"
    },
    "sizes": {
      "LARGE": "Large",
      "MEDIUM": "Medium",
      "SMALL": "Small"
    },
    "everyoneSees": "Shortlist · everyone sees",
    "cardFields": "Card fields",
    "cardSize": "Card size",
    "clientDefaultFilter": "Client's default filter",
    "availability": "Availability",
    "addResources": "Add resources"
  },
  "ShortlistBoardTags": {
    "title": "Team tags"
  },
  "ShortlistBoardHero": {
    "title": "Title the client sees",
    "titlePlaceholder": "Add a title",
    "description": "Description the client sees",
    "descriptionPlaceholder": "Add a description"
  },
  "ShortlistVersionSwitch": {
    "title": "Shortlists",
    "newVersionDescription": "You're trying the new shortlists. They're still experimental — if something looks off, switch back. Your shortlists stay the same.",
    "oldVersionDescription": "You're on the classic shortlists. The new ones are in beta — give them a go anytime."
  },
  "VoteButtons": {
    "voteUp": "Vote up",
    "voteDown": "Vote down",
    "voteFailed": "Couldn't save your vote. Try again.",
    "upvotes_one": "{{count}} vote for",
    "upvotes_other": "{{count}} votes for",
    "downvotes_one": "{{count}} vote against",
    "downvotes_other": "{{count}} votes against",
    "comments_one": "{{count}} comment",
    "comments_other": "{{count}} comments",
    "openComments": "Comments"
  },
  "ShortlistClientHeader": {
    "people_one": "{{count}} person",
    "people_other": "{{count}} people",
    "updated": "updated {{when}}",
    "showMore": "Show more",
    "showLess": "Show less",
    "tags": "Tags"
  },
  "ShortlistBoardBody": {
    "empty": "Nobody on this shortlist yet.",
    "people": "People on the shortlist",
    "unnamed": "Unnamed resource",
    "loading": "Loading…",
    "loadingPeople": "Loading people",
    "loadFailed": "The shortlist couldn't be loaded.",
    "rowFailed": "Couldn't load this person.",
    "saveFailed": "The change couldn't be saved. Try again.",
    "pick": "Pick",
    "drag": "Drag to move",
    "editGallery": "Edit gallery",
    "noMatches": "Nobody on this shortlist matches."
  },
  "ShortlistSelector": {
    "updated": "Updated {{when}}",
    "untitled": "Untitled shortlist"
  },
  "PublicShortlistPasswordGate": {
    "private": "Private shortlist",
    "label": "Password",
    "showPassword": "Show password",
    "required": "Enter the password",
    "wrong": "That password didn't open the shortlist. Try again.",
    "failed": "Couldn't check the password. Check your connection and try again.",
    "submit": "Open shortlist",
    "help": "No password? Ask whoever sent you the link."
  },
  "ShortlistClientBoard": {
    "unpublishedTitle": "Not published",
    "unpublishedMessage": "Clients who open the link see this shortlist as unavailable."
  },
  "PublicShortlistLoadFailed": {
    "title": "Couldn't open the shortlist",
    "message": "Check your connection and try again."
  },
  "PublicShortlistUnavailable": {
    "title": "This shortlist isn't available",
    "message": "It may have been unpublished or the link has changed. Ask the person who shared it for a new link."
  },
  "ViewingAs": {
    "label": "Viewing as",
    "labelGuest": "Viewing as guest",
    "guest": "Guest",
    "addName": "Add your name",
    "changeName": "Change name"
  },
  "ClientVoteProgress": {
    "voted": "{{voted}} of {{total}} voted"
  },
  "AtellioFooter": {
    "madeWith": "Shortlist made with Atellio, the talent platform for production teams.",
    "learnMore": "Learn more"
  },
  "ShortlistSearchFilters": {
    "search": "Search this shortlist"
  },
  "GuestNameDialog": {
    "title": "Your name",
    "description": "Tell the shortlist's owner who you are before you vote or comment.",
    "label": "Your name",
    "placeholder": "First and last name",
    "required": "Enter your name",
    "save": "Save name"
  },
  "QrField": {
    "label": "QR code",
    "setUp": "Set up QR code",
    "notSetUp": "No content chosen for the QR code yet.",
    "cannotBuild": "Cannot generate the QR code",
    "openSettings": "Team settings",
    "missing_one": "{{count}} field missing",
    "missing_other": "{{count}} fields missing",
    "missingHint": "Required for this person's type and empty: {{slots}}",
    "slots": {
      "gender": "Gender",
      "bust": "Bust",
      "waist": "Waist",
      "height": "Height",
      "shoe": "Shoe",
      "bra_size": "Bra size"
    },
    "copyValue": "Copy value",
    "copied": "Copied",
    "downloadSvg": "Download SVG",
    "hoverHint": "Hover the code to see what the scanner reads. Click it to hide or show the logo.",
    "cannotBuildHint": "{{slots}}: the mapped field was deleted in the team's custom fields.",
    "hideLogo": "Hide the logo",
    "showLogo": "Show the logo"
  },
  "ShortlistPdf": {
    "people_one": "{{count}} person",
    "people_other": "{{count}} people",
    "printedOn": "Printed {{date}}",
    "page": "Page {{number}} of {{total}}",
    "votes": "{{up}} up · {{down}} down",
    "up": "{{count}} up",
    "down": "{{count}} down",
    "sheetTitle": "Person sheet",
    "scanTitle": "QR code for the shot",
    "scanHint": "Print it and place it in the frame. The photo then carries this person's name, groups, measurements and resource id, so it lands in the database with its parameters.",
    "failed": "The PDF couldn't be made. Try again.",
    "menu": {
      "download": "Download PDF…",
      "person": "Download person sheet",
      "actions": "Actions for {{name}}",
      "button": "Download PDF"
    },
    "dialog": {
      "title": "Download PDF",
      "description": "Choose what goes into the file.",
      "scope": {
        "label": "Who to include",
        "all": "Everyone on the shortlist",
        "filtered": "As filtered on the page",
        "selected": "The people picked"
      },
      "layout": {
        "label": "Layout",
        "grid": "Grid",
        "gridHint": "Eight people to a page",
        "person": "Person sheets",
        "personHint": "One person to a page, with large pictures",
        "slate": "QR slates",
        "slateHint": "A large QR code for each person, to place in the frame"
      },
      "paper": {
        "label": "Paper",
        "a4": "A4",
        "letter": "Letter"
      },
      "qr": {
        "label": "QR code",
        "description": "Print each person's code"
      },
      "summary_one": "{{count}} person in the file",
      "summary_other": "{{count}} people in the file",
      "loading": "Loading people…",
      "loadFailed": "The people couldn't be loaded.",
      "empty": "Nobody to put in the file.",
      "submit": "Download",
      "pictures": "Fetching pictures {{completed}} of {{total}}",
      "drawing": "Drawing the pages…",
      "slates": {
        "label": "Slates",
        "one": "One to a page",
        "four": "Four to a page, with cut lines"
      },
      "summarySlates_one": "{{count}} QR slate in the file",
      "summarySlates_other": "{{count}} QR slates in the file",
      "skipped_one": "{{count}} person has no QR value and gets no slate",
      "skipped_other": "{{count}} people have no QR value and get no slate",
      "noSlates": "Nobody here has a QR value."
    },
    "madeWith": "Made with",
    "slateCut": "Cut along the dashed lines"
  }
}
